"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../utils");
const styles = require('./withSpacing.module.scss');
const withSpacing = (Component) => {
    const WithSpacing = (_a, ref) => {
        var { hasSpacing } = _a, props = __rest(_a, ["hasSpacing"]);
        return hasSpacing ? (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                [styles['spacing-2']]: hasSpacing,
            }), ref: ref },
            react_1.default.createElement(Component, Object.assign({}, props)))) : (react_1.default.createElement(Component, Object.assign({}, props, { ref: ref })));
    };
    WithSpacing.displayName = `withSpacing(${(0, utils_1.getComponentName)(Component)})`;
    return (0, react_1.memo)(react_1.default.forwardRef(WithSpacing));
};
exports.default = withSpacing;
//# sourceMappingURL=withSpacing.js.map